<app-management-sidemenu
  [(isOpen)]="isSideNavOpen"
  [managementType]="selectedManagementType"
  [actionType]="selectedActionType"
  (close)="isSideNavOpen = false"
  [selectedCompany]="selectedCompany"
  (refreshTable)="getPaginatedQuery()"
>
  <h1>{{ "companyManagement" | localize }}</h1>
  <div
    class="company-management-container custom-admin-label-class"
    [ngClass]="{
      'sidenav-open': isSideNavOpen,
      'sidenav-close': !isSideNavOpen
    }"
  >
    <div class="company-management-header">
      <div class="company-management-process">
        <button
          class="add-new-company"
          style="cursor: pointer"
          (click)="
            openSideNav(ManagementType.CompanyManagement, ActionType.Create)
          "
        >
          <span> {{ "newCompany" | localize }} </span>
          <img src="assets/icons/general/add-icon.png" alt="" />
        </button>
      </div>
    </div>

    <!-- Table -->
    <div class="table-container">
      <div class="table-responsive">
        <mat-table [dataSource]="dataSource">
          <!-- companyLogo Column -->
          <ng-container class="companyLogoUrl" matColumnDef="companyLogoUrl">
            <th mat-header-cell *matHeaderCellDef>
              {{'companyLogoUrl' | localize}}
            </th>
            <td mat-cell *matCellDef="let element">
              <img class="company-image" *ngIf="element.imagePath" [src]="element.imagePath" />
            </td>
          </ng-container>

          <!-- companyName Column -->
          <ng-container matColumnDef="companyName">
            <mat-header-cell *matHeaderCellDef class="custom-header-cell">

              <mat-form-field class="custom-header-field"
                              appearance="fill"
                              floatLabel="auto"
                              subscriptSizing="dynamic">
                <mat-label>{{ "companyName" | localize }}</mat-label>

                <input matInput
                       [(ngModel)]="inputValues['companyName']"
                       (input)="onInputChange($event, 'companyName')" />

              </mat-form-field>

            </mat-header-cell>

            <mat-cell *matCellDef="let element"
                      matTooltip="{{ element.companyName }}"
                      matTooltipPosition="below">
              {{ element.companyName }}
            </mat-cell>
          </ng-container>

          <!-- registrationType Column -->
          <ng-container matColumnDef="registrationTypeId">
            <mat-header-cell *matHeaderCellDef class="custom-header-cell">
              <mat-form-field class="custom-header-field"
                              appearance="fill"
                              floatLabel="auto"
                              subscriptSizing="dynamic">
                <mat-label>{{ "registrationType" | localize }}</mat-label>

                <mat-select [(ngModel)]="inputValues['registrationTypeId']"
                            (selectionChange)="onSelectBoxInputChange($event.value, 'registrationTypeId')">
                  <mat-option [value]="null">{{ "all" | localize }}</mat-option>

                  <mat-option *ngFor="let opt of allRegistrationTypes"
                              [value]="opt.value">
                    {{ opt.labelKey | localize }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-header-cell>

            <mat-cell *matCellDef="let element"
                      matTooltip="{{ getRegistrationTypeName(element.registrationTypeId) }}"
                      matTooltipPosition="below">
              {{ getRegistrationTypeName(element.registrationTypeId) }}
            </mat-cell>
          </ng-container>

          <!-- subscriptionLabelType Column -->
          <ng-container matColumnDef="subscriptionLabelId">
            <mat-header-cell *matHeaderCellDef class="custom-header-cell">

              <mat-form-field class="custom-header-field"
                              appearance="fill"
                              floatLabel="auto"
                              subscriptSizing="dynamic">
                <mat-label>{{ "subscriptionLabelType" | localize }}</mat-label>

                <mat-select [(ngModel)]="inputValues['subscriptionLabelId']"
                            (selectionChange)="
          onSelectBoxInputChange($event.value, 'subscriptionLabelId')
        ">
                  <mat-option [value]="null">{{ "all" | localize }}</mat-option>

                  <mat-option *ngFor="let opt of allSubscriptionLabelTypes"
                              [value]="opt.value">
                    {{ opt.labelKey | localize }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

            </mat-header-cell>

            <mat-cell *matCellDef="let element"
                      matTooltip="{{ getSubscriptionLabelTypeName(element.subscriptionLabelId) }}"
                      matTooltipPosition="below">
              {{ getSubscriptionLabelTypeName(element.subscriptionLabelId) }}
            </mat-cell>
          </ng-container>

          <!-- subscriptionType Column -->
          <ng-container matColumnDef="subscriptionTypeId">
            <mat-header-cell *matHeaderCellDef class="custom-header-cell">
              <mat-form-field class="custom-header-field"
                              appearance="fill"
                              floatLabel="auto"
                              subscriptSizing="dynamic">
                <mat-label>{{ "subscriptionType" | localize }}</mat-label>

                <mat-select [(ngModel)]="inputValues['subscriptionTypeId']"
                            (selectionChange)="
          onSelectBoxInputChange($event.value, 'subscriptionTypeId')
        ">
                  <mat-option [value]="null">{{ "all" | localize }}</mat-option>

                  <mat-option *ngFor="let opt of allSubscriptionTypes"
                              [value]="opt.value">
                    {{ getSubscriptionTypeName(opt.value) }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-header-cell>

            <mat-cell *matCellDef="let element"
                      matTooltip="{{ getSubscriptionTypeName(element.subscriptionTypeId) }}"
                      matTooltipPosition="below">
              {{ getSubscriptionTypeName(element.subscriptionTypeId) }}
            </mat-cell>
          </ng-container>

          <!-- options Column -->
          <ng-container matColumnDef="options">
            <mat-header-cell class="options-column" *matHeaderCellDef>
              #
            </mat-header-cell>
            <mat-cell class="options-cell" *matCellDef="let element">
              <button
                mat-icon-button
                [matMenuTriggerFor]="actionMenu"
                aria-label="Options"
              >
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu class="options-menu" #actionMenu="matMenu">
                <div class="menu-header">{{ "transactions" | localize }}</div>
                <button
                  mat-menu-item
                  (click)="
                    openSideNav(
                      ManagementType.CompanyManagement,
                      ActionType.Update,
                      element
                    )
                  "
                >
                  <img
                    src="assets/icons/general/edit-project-icon.png"
                    alt=""
                  />
                  {{ "edit" | localize }}
                </button>

                <button mat-menu-item (click)="deleteCompany(element)">
                  <img
                    src="assets/icons/general/delete-project-icon.png"
                    alt=""
                  />
                  {{ "companyDelete" | localize }}
                </button>
              </mat-menu>
            </mat-cell>
          </ng-container>

          <!-- Define rows -->
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
      </div>

      <!--Paginator-->
      <div class="custom-paginator">
        <span *ngIf="companySearchLength > 0; else noRecords">
          {{ companySearchLength }} {{ 'entries' | localize }} {{ currentPage * pageSize + 1 }} -
          {{ Math.min(companySearchLength, (currentPage + 1) * pageSize) }}
          {{ 'betweenDisplayed' | localize }}
        </span>
        <ng-template #noRecords> {{ 'noRecordFound' | localize }} </ng-template>

        <!-- Paginator Buttons -->
        <button (click)="onPageChange(0)" [disabled]="currentPage === 0">
          &laquo;
        </button>
        <button
          (click)="onPageChange(currentPage - 1)"
          [disabled]="currentPage === 0"
        >
          &lt;
        </button>
        <ng-container *ngFor="let page of visiblePageNumbers">
          <button
            [class.active]="page - 1 === currentPage"
            (click)="onPageChange(page - 1)"
          >
            {{ page }}
          </button>
        </ng-container>
        <button
          (click)="onPageChange(currentPage + 1)"
          [disabled]="currentPage >= totalPages - 1"
        >
          &gt;
        </button>
        <button
          (click)="onPageChange(totalPages - 1)"
          [disabled]="currentPage >= totalPages - 1"
        >
          &raquo;
        </button>
        <!--PageSize selection-->
        <select [(ngModel)]="pageSize" (change)="updatePageSize($event)">
          <option *ngFor="let option of [5, 10]" [value]="option">
            {{ option }}
          </option>
        </select>
      </div>
    </div>
  </div>
</app-management-sidemenu>
